import { FleekError } from './FleekError';

type Pin = {
  id?: string;
  cid?: string;
  path?: string;
  projectId?: string;
};

type PinAlreadyExistsInProjectErrorOptions = {
  pin: Pin;
};

export class PinAlreadyExistsInProjectError extends FleekError<PinAlreadyExistsInProjectErrorOptions> {
  public name = 'PinAlreadyExistsInProjectError';

  toString = () => {
    return `Pin with the same '${this.data.pin.cid ? 'cid' : 'path'}' already exists within the project.`;
  };
}
